import {
  Link as MuiLink,
  Typography as MuiTypography,
  Tooltip as MuiTooltip,
} from "@mui/material";

const DownloadLink = ({ href, filename, downloadFile }) => {
  return (
    <MuiTooltip title={filename} placement="bottom">
      <MuiLink
        component="button"
        href={href}
        onClick={(event) => {
          event.preventDefault();
          downloadFile(href);
        }}
        sx={{ textDecoration: "none", textAlign: "left" }}
      >
        <MuiTypography
          sx={{
            fontSize: "14px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "400px",
          }}
        >
          {filename}
        </MuiTypography>
      </MuiLink>
    </MuiTooltip>
  );
};

export default DownloadLink;
